import { render, staticRenderFns } from "./ProductPlayer.vue?vue&type=template&id=5a97860e&scoped=true&"
import script from "./ProductPlayer.vue?vue&type=script&lang=js&"
export * from "./ProductPlayer.vue?vue&type=script&lang=js&"
import style0 from "./ProductPlayer.vue?vue&type=style&index=0&id=5a97860e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a97860e",
  null
  
)

export default component.exports